import React from 'react';

export default function LogOut() {
    localStorage.removeItem('token');

    return <div style={{margin:"15px"}}>Successfully logged out.</div>;
}
